import { config } from './config.js';
import { AbstractApi } from './abstract-api.js';

export type CleanupMode = 'NONE' | 'ONCE' | 'RECURRING';

export interface CleanupData {
  purchased: CleanupMode;
  notInAssortment: CleanupMode;
}

export interface CleanupApi {
  cleanup(data: CleanupData): Promise<boolean>;
  getState(): Promise<CleanupData>;
}

class CleanupApiClass extends AbstractApi implements CleanupApi {
  async cleanup(data: CleanupData): Promise<boolean> {
    return this.post(`${config.apiEndpoint}cleanup`, 'Wishlist', data);
  }

  async getState(): Promise<CleanupData> {
    return this.get<CleanupData>(`${config.apiEndpoint}cleanup`, 'Wishlist');
  }
}

export const cleanupApiInstance: CleanupApi = new CleanupApiClass();
